import React from 'react'
import {isOfferValidToday, TEXT, urlCreator} from '../Common.js'

class Item extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            imageLoaded: false
        }
    }

    addSimpleCampaigns(){
        let campaignRenderList = []
        this.props.item.benefits.sort(function(a, b) {
            return parseInt(a.order) - parseInt(b.order)
        })
        this.props.item.benefits.forEach(function (el, i) {
            if(isOfferValidToday(el.fromdate, el.todate)) {
                if((el.title !== ' ' && el.title !== '') || (el.benefit !== ' ' && el.benefit !== '')) {
                    campaignRenderList.push(<p key={i}>
                        {el.type !== 'TABLERESERVATION' ? <span><i className="fas fa-tag float-left"></i></span> : null}
                            <span className="cs-offer-description">
                                {el.title !== ' ' && el.title !== '' ? el.title : null}
                            </span>
                        </p>
                    )
                    //{el.benefit !== ' ' && el.benefit !== '' ? el.benefit : null}
                }
            }
        })
        if(campaignRenderList.length > 3) {
            campaignRenderList = campaignRenderList.slice(0, 3);
            campaignRenderList.push(<div key="1000" className={"esd-divider-ellipsis"}><p>...</p></div>)
        }
        return campaignRenderList
    }

    handleImageLoaded =()=>{
        this.setState({imageLoaded: true})
    }

    render(){
        const item = this.props.item
        const singleUrl = "/edut/"+ urlCreator(item.title)+"/"+item.id
        //const grid_class = parseInt(window.BLOCKVARS_ITEMS_PER_PAGE ? 12/window.BLOCKVARS_ITEMS_PER_PAGE : 1)/window.BLOCKVARS_ITEMS_PER_ROW.toString();
        const grid_class = parseInt(window.BLOCKVARS_ITEMS_PER_ROW ? 12/window.BLOCKVARS_ITEMS_PER_ROW : 1).toString();
        return (
            <div className={"col-xs-12 col-md-6 col-lg-" + grid_class}>
                <div className="cs-box-offer">
                    <a
                        href={singleUrl}
                        className={"cs-img-box" + (!this.state.imageLoaded ? " esd-loading" : "")}
                        title={"Katso " + this.props.item.title + " edut ja alennukset"}
                    >
                        <img className="img-fluid" src={this.props.item.image.replace('.jpg', '-tn.jpg')} onLoad={this.handleImageLoaded} alt={this.props.item.title + " ilmoitus"} />
                    </a>
                    <h3>{this.props.item.title}</h3>
                    <section>{this.addSimpleCampaigns()}</section>
                    <a
                        href={singleUrl}
                        className="btn btn-primary btn-link"
                        title={"Katso " + this.props.item.title + " edut ja alennukset"}
                    >
                    {TEXT.fi.more}
                    </a>
                </div>
            </div>
        )
    }
}

export default Item